module["exports"] = [
  "#{city_root}#{city_suffix}"
];
